export default "__VITE_ASSET__Np5Z58bJ__"